<template>
    <el-dialog title="配置商品标签" :visible.sync="labelVisible" width="500px" :close-on-click-modal="false"
        :destroy-on-close="true" :before-close="beforeClose">
        <div style="margin-bottom: 10px;color: #999;">您可以自定义商品标签，便于用户在小程序快速筛选商品</div>
        <el-table max-height="500px" border empty-text="暂无数据" :data="labelList">
            <el-table-column label="标签名称" prop="name">
                <template v-slot="scope">
                    <div v-if="scope.row.edit">
                        <el-input v-model="scope.row.name" placeholder="请输入标签名称" maxlength="10"></el-input>
                    </div>
                    <div v-else>{{ scope.row.name }}</div>
                </template>
            </el-table-column>
            <el-table-column label="关联商品数量" prop="goodsCount">
                <template v-slot="scope">
                    <div>{{ scope.row.goodsCount || 0 }}</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
                <template v-slot="scope">
                    <el-button v-if="scope.row.edit" @click="addLabel(scope.row)" type="text"
                        size="small">保存</el-button>
                    <el-popconfirm title="确定要删除？" v-if="!scope.row.edit" @confirm="deleteLabel(scope.row)">
                        <el-button slot="reference" type="text" size="small">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-button v-show="!(labelList.slice(-1)[0] && labelList.slice(-1)[0].edit)"
            style="border: 1px #dcdfe6 dashed;margin-top: 20px;padding: 10px;width: 100%;" @click="addLabelClick">添加标签
        </el-button>
    </el-dialog>
</template>

<script>
export default {
    name: 'LabelDialog',
    props: {
        labelVisible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            labelList: []
        }
    },
    watch: {
        labelVisible: {
            handler(newVal) {
                if (newVal) {
                    this.getlabelList();
                }
            },
            immediate: true
        }
    },
    methods: {
        beforeClose() {
            this.$emit('update:labelVisible', false);
        },
        async getlabelList() {
            let url = "/api/v1/manage/travelLabel";
            let { code, data } = await this.$axios.get(url);
            if (code === 1) {
                this.labelList = data;
            }
        },
        /* 删除标签 */
        async deleteLabel(item) {
            let url = `/api/v1/manage/travelLabel/${item.id}`;
            let { code } = await this.$axios.delete(url);
            if (code === 1) {
                this.$message.info("标签删除成功");
                this.getlabelList();
                this.$emit('refresh', item.id);
            }
        },
        /* 添加标签 */
        async addLabel(item) {
            if (!item.name) {
                this.$message.warning("请输入标签名称");
                return;
            }
            let url = "/api/v1/manage/travelLabel";
            let { code } = await this.$axios.post(url, {
                name: item.name,
                goodsNum: 0
            });
            if (code === 1) {
                this.$message.info("标签添加成功");
                this.getlabelList();
                this.$emit('refresh');
            }
        },
        addLabelClick() {
            // if (this.labelList.length == 30) {
            //     this.$message.info("最多添加30个标签");
            //     return;
            // }
            this.labelList.push({ name: null, edit: true });
        },
    }
}
</script>

<style></style>